import { useEffect, useRef } from 'react'
import { useSelector } from 'store/redux.store'
import { SurvicateProps } from './survicate.types'
declare global {
  interface Window {
    _sva: any
  }
}

export async function useAddUserIdOnSurvicate() {
  const { user, context } = useSelector(state => state)

  const isFetchUserTypeAlreadyCalled = useRef(false)
  const isFetchRevenueSegmentationAlreadyCalled = useRef(false)
  const isClusterNameAlreadyDefined = useRef(false)
  const isUserIdLanguageOrCountryAlreadyDefined = useRef(false)

  const userRef = useRef<SurvicateProps>({})

  useEffect(() => {
    if (isUserIdLanguageOrCountryAlreadyDefined.current) {
      return
    }

    userRef.current.user_id = user?.id
    ;(userRef.current.language = user?.language), (userRef.current.country = user?.address?.country)

    if (user?.id) {
      isUserIdLanguageOrCountryAlreadyDefined.current = true
    }

    window?._sva?.setVisitorTraits(userRef.current)
  }, [user])

  useEffect(() => {
    if (isFetchUserTypeAlreadyCalled.current) {
      return
    }

    ;(async () => {
      if (context?.userTypeInfo?.userType) {
        userRef.current.userType = context.userTypeInfo.userType
        isFetchUserTypeAlreadyCalled.current = true
      }

      window?._sva?.setVisitorTraits(userRef.current)
    })()
  }, [])

  useEffect(() => {
    if (isFetchRevenueSegmentationAlreadyCalled.current) {
      return
    }

    ;(async () => {
      if (context?.userTypeInfo?.userSegmentationInfo) {
        userRef.current.revenueSegmentation = context.userTypeInfo.userSegmentationInfo
        isFetchRevenueSegmentationAlreadyCalled.current = true
      }
      window?._sva?.setVisitorTraits(userRef.current)
    })()
  }, [])

  useEffect(() => {
    if (isClusterNameAlreadyDefined.current) {
      return
    }

    if (user?.cluster?.clusterName) {
      userRef.current.clusterName = user?.cluster?.clusterName
      isClusterNameAlreadyDefined.current = true
    }
    window?._sva?.setVisitorTraits(userRef.current)
  }, [user?.cluster?.clusterName])
}
